export default "__VITE_PUBLIC_ASSET__a4bb7e7a__"